import React from 'react';
import { Modal, Tabs } from 'antd';
import { useQuery } from 'react-query';

import Consequences from './Consequences';
import { getTaskConseqEntity } from 'services/workflow';

import Button from 'components/Button';
import { noop } from 'lodash';
import DF from 'DisplayFramework';

const { TabPane } = Tabs;

export type ConseqModalProps = {
  entityId: number;
  entity: string;
  onCancel: () => void;
  conseqid: number;
  taskid: number;
  visible: boolean;
  title:string;
  onSuccess?: () => void;
};

const ConseqModal = ({
  entityId,
  entity,
  onCancel,
  conseqid,
  taskid,
  visible,
  title,
  onSuccess = noop,
}: ConseqModalProps) => {
  const params = {
    entity: entity,
    entityid: entityId,
    conseqid: conseqid,
    taskid: taskid,
  };

  const { data: consequences } = useQuery(
    ['getTaskConseqEntity', params],
    () => getTaskConseqEntity(params).then((res) => res.list ?? undefined),
    { enabled: true }
  );

  return (
    (<DF.Provider pagcode="conseqmodal">
      <Modal
        open={visible}
        onCancel={onCancel}
        width={800}
        title={title}
        footer={[<Button key="cancel" comcode="cancel" onClick={onCancel} />]}
      
      >
        <Tabs>
          <TabPane tab="Consequences" key="consequences">
            <Consequences consequences={consequences} />
          </TabPane>
        </Tabs>
      </Modal>
    </DF.Provider>)
  );
};

export default ConseqModal;
